import { Route, Routes as RouterRoutes } from 'react-router';

import { OvdTokenCreateContainer } from './ovd_token_create_container';
import { OvdTokenEditContainer } from './ovd_token_edit_container';
import { OvdTokenListContainer } from './ovd_token_list_container';
import { Routes } from '../../routes';

export const OvdTokensContainer = () => {
  return (
    <RouterRoutes>
      <Route path={Routes.OvdTokenCreate.relativePath} element={<OvdTokenCreateContainer />} />
      <Route path={Routes.OvdTokenDetail.relativePath} element={<OvdTokenEditContainer />} />
      <Route index element={<OvdTokenListContainer />} />
    </RouterRoutes>
  );
};
